var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.mask),expression:"$store.state.mask"}],staticClass:"masklayer"})
}
var staticRenderFns = []

export { render, staticRenderFns }